import React, {PureComponent} from 'react';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import InputRegular from '../../common/InputRegular';
import Header from '../Header'
import {Link} from "react-router-dom";
import Input from "../../common/Input";
// import ReactGA from "react-ga";

class TeamMembers extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            user: {},
            teamMembers: ['member_1', 'member_2', 'member_3'],
            showLink: false,
            hasError: true,
            data:
                {
                    member_1: '',
                    member_2: '',
                    member_3: ''
                },
            spinnerActive: false,
            errors: {},
            memberFocused: '',
            fieldsCheckActive: false,
            errorsList: [],
        };
    }

    

    getEmailsFromInputs = () => {
        const collection = document.getElementsByTagName("input");
        const inputs = [...collection];

        const emails = inputs.map(input => {
            if (input.value) {
                return input.value;
            } else {
                return null
            }
        });
        return emails.filter(function (el) {
            return el != null;
        });
    };


    doSubmit = async () => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Add teammates - Add teammates',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = await this.state.data.member_1 ? false : true;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {
                try {

                    const userId = await getCurrentUserId();
                    const teamId = localStorage.getItem("selectedTeam") || localStorage.getItem("team_id");
                    const emails = this.getEmailsFromInputs();
                    if (userId && emails.length > 0) {

                        await this.setState({spinnerActive: true});
                        const resp = await http.post('api/user/' + userId + '/team/' + teamId + '/member', {emails: emails}, {headers: {authorization: getJwt()}});
                        this.setState({spinnerActive: false});
                    }
                    if (localStorage.navigateBackTo) {
                        this.props.history.push(localStorage.navigateBackTo)
                        localStorage.removeItem('navigateBackTo')
                    } else {
                        this.props.history.push('/workspace-settings')
                    }
                } catch (ex) {
                    this.setState({spinnerActive: false});
                }
            }
        }, 500)
    };

    copyLink(e) {
        e.preventDefault();
        var copyText = document.getElementById("input-button");
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        alert('Copied!');
    }

    componentDidMount() {
        // ReactGA.pageview(window.location.pathname + window.location.search);

        
    }

    showInviteLink = () => {
        let show = this.state.showLink;
        show = show !== true;
        this.setState({
            showLink: show
        })
    };

    componentDidUpdate() {
        // this.updateSchema()
    }


    addNewMember = () => {
        let teamMembers = [...this.state.teamMembers];
        let membersCount = teamMembers.length + 1;
        let newMember = 'member_' + membersCount;

        teamMembers.push(newMember);

        let data = {...this.state.data};
        data[newMember] = '';

        this.setState({
                teamMembers: this.state.teamMembers.concat(newMember),
                data: data
            }
        );
    };

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    render() {

        return (
            <div className='onboarding-container'>
                {/*{console.log('inputs',document.getElementsByTagName("input"))}*/}
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title distribution-title m-lg-b'><span>Who else is a part of</span>
                            <br/>
                            <span>this team?</span></h1>


                        <div id='team-members'>
                            {this.state.teamMembers.map((member, index) => {


                                    return <div key={member}>
                                        <InputRegular
                                            id={(index + 1).toString()}
                                            label1=""
                                            label2=""
                                            placeholder="Email"
                                            type='email'
                                            onChange={async (value) => {
                                                let errorsList = this.state.errorsList;
                                                if (index.toString() !== '0' && value === '') {
                                                    errorsList[index] = await false;
                                                }
                                                await this.setState({
                                                    data: {
                                                        ...this.state.data,
                                                        ['member_' + (index + 1)]: value
                                                    },
                                                    errorsList
                                                });
                                            }}
                                            value={this.state.data['member_' + (index + 1)]}
                                            required={index.toString() === '0' || this.state.data['member_' + (index + 1).toString()] ? true : false}
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            updateErrorsList={this.updateErrorsList}
                                            errorMessage="Please enter valid email address"
                                        />
                                        {/*{this.renderInput(member, 'text', 'name@example.com', false, false, 'auto','', (member)=>this.setState({memberFocused: member}))}*/}

                                    </div>
                                }
                            )
                            }


                        </div>
                        <p
                            className=' add-new-member  m-s-t m-m-b text-right'>
                            <p className='text-light-blue pointer' onClick={this.addNewMember}>
                                <span className='fas fa-plus-circle'></span>
                                Add another
                            </p></p>


                        {!this.state.spinnerActive ?
                            <button className='btn-action' onClick={this.doSubmit}>Add Teammates</button>
                            :
                            <button className='btn-action btn-spinner' disabled={true}>Add Teammates <i
                                className='fa fa-spin fa-spinner'></i></button>
                        }

                        <div className='panel-message text-center'>
                            <p>Or, {
                                localStorage.navigateBackTo ?
                                    <Link to="#" onClick={() => {
                                        if (localStorage.navigateBackTo === '/choose-team') {
                                            this.props.history.push('/choose-team')
                                            localStorage.removeItem('navigateBackTo');
                                        } else {
                                            this.props.history.push(localStorage.navigateBackTo);
                                            localStorage.removeItem('navigateBackTo');
                                            localStorage.removeItem('selectedTeam');
                                        }
                                    }}>skip for now</Link> :
                                    <Link to="#" onClick={() => {
                                        this.props.history.push('/workspace-settings',
                                            // ReactGA.event({
                                            //     category: 'Click',
                                            //     action: 'Add teammates - Skip',
                                            //     userId: getCurrentUserId(),
                                            //     label: '',
                                            //     nonInteraction: true
                                            //}
                                            //)
                                        )
                                    }}> skip for now
                                    </Link>
                            }</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TeamMembers;